// CSV utilities
export function toCSV(rows, headers) {
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v);
    if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };
  const headerLine = headers.map((h) => escape(h.label)).join(";");
  const lines = rows.map((r) => headers.map((h) => escape(h.get(r))).join(";"));
  return [headerLine, ...lines].join("\n");
}

export function downloadCSV(filename, csv) {
  // BOM para compatibilidade com Excel
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 200);
}

export const brMoney = (v) =>
  `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

export const formatDateBR = (iso) => {
  try {
    return new Date(iso).toLocaleString("pt-BR");
  } catch {
    return iso;
  }
};
